<template>
  <div class="home">
    <div style="margin: 20px">
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: center;
          font-size: 12pt;
        "
      >
        <span style="font-family: SimSun; font-weight: bold"
          >Privacy Policy</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Effective Date: January 31, 2026(GMT+8)</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >Welcome to Our Game!</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　We respect your privacy and are committed to safeguarding your
          personal information.This Privacy Policy explains how we
          collect,use,store,and protect your data when you use our
          application.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >1.Information We Collect</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　During your use of Our Game,we may collect and process the
          following types of data:</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Device Information:Such as your device model,operating system,and
          advertising identifier(Advertising ID).This helps us deliver optimized
          performance and relevant advertising.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Account Information:Your Apple ID,used for secure login and
          social interaction features.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Payment Information:Required for processing in-app purchases or
          subscription payments.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Game Data:Includes gameplay progress,virtual currency balance,and
          activity logs to improve your user experience.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >2.How We Use Your Information</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　The information we collect is used for the following legitimate
          purposes:</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　To support essential app features such as login
          authentication,in-app purchases,and game data synchronization.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　To enhance the functionality,stability,and user experience of the
          application.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　To deliver personalized advertisements and content
          recommendations.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　To analyze gameplay behavior and optimize performance.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >3.Permissions and Their Purposes</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　To ensure proper operation of the app,we may request access to
          certain permissions on your device:</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Network Access:For connecting to servers and loading in-game
          resources.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Microphone and Camera Access:To enable voice chat and real-time
          video interactions.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Device Features:Such as vibration and screen wake-up for game
          effects.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Payment Authorization:For handling secure in-app purchase
          transactions.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Advertising and Analytics IDs:Including Google Service Framework
          ID and Advertising ID,for analytics and ad attribution.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Media Storage Access:To allow users to upload and save photos or
          videos.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Push Notifications and Crash Reporting:Managed through Firebase
          for stability monitoring and real-time communication.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >4.Third-Party Services and SDKs</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　To provide stable functionality and optimize the app
          experience,This Game integrates third-party software development
          kits(SDKs)and services.These partners may process limited data under
          strict compliance and security policies:</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Firebase:Used for crash analytics,performance monitoring,and push
          notifications.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Appsflyer:Provides advertising attribution and user behavior
          analytics.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Google Login&amp;Payments:Offers secure and convenient login and
          payment options.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Facebook Login:Enables social account login features.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Alibaba Cloud OSS:Used to store user-uploaded photos and
          videos.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Tencent IM&amp;TRTC:Supports real-time communication and social
          voice chat services.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　All third-party providers are required to comply with data
          protection laws and contractual confidentiality obligations.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >5.Data Storage and Security</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Your information is stored both locally on your device and on
          Alibaba Cloud servers located in Singapore.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　We employ multiple layers of protection to ensure data
          security:</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Data Encryption:All transmitted and stored data is encrypted to
          prevent unauthorized access.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Access Control:Only authorized personnel are allowed to access
          user data.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Regular Backups:Data is periodically backed up to prevent
          accidental loss.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Security Monitoring and Auditing:Continuous system monitoring
          detects and blocks potential security threats.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >6.Data Sharing</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　We may share encrypted and limited data with third parties for
          legitimate purposes such as analytics and advertising
          optimization.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　These include:</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Google Ads,Facebook Ads,and Appsflyer:For improving advertisement
          targeting and effectiveness analysis.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　All shared data remains encrypted,anonymized where possible,and
          is never used for any unauthorized purposes.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >7.Protection of Minors</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　This Game is intended for users aged 18 and above.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　We do not knowingly collect personal information from
          minors.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　If we become aware that a minor has provided us with personal
          data,we will take immediate steps to delete such information.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >8.Your Rights</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　You have full control over your personal data and may exercise
          the following rights:</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Access,Modify,or Delete Your Data:You can access or manage your
          data directly through in-app settings or by contacting our support
          team.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　Manage Permissions or Opt Out:You may withdraw permissions or
          disable data collection through your device settings at any
          time.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　We will process such requests promptly and in accordance with
          applicable data protection laws.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >9.Entertainment Disclaimer</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　This application is designed for entertainment purposes
          only.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　It does not involve real-money gambling,wagering,or any
          cash-related transactions.</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　</span
        ><span style="font-family: SimSun; font-weight: bold"
          >10.Contact Us</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　If you have any questions,comments,or concerns about this Privacy
          Policy or our data handling practices,please contact us at:</span
        >
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun">　　Email:huangyf@acepokr.com</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 10.5pt">
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 0pt; font-size: 12pt">
        <span style="font-family: SimSun"
          >　　We will respond as soon as possible to address your
          inquiry.</span
        >
      </p>
      <p
        style="
          margin-top: 0pt;
          margin-bottom: 0pt;
          text-align: justify;
          widows: 0;
          orphans: 0;
          font-size: 10.5pt;
        "
      >
        <span style="font-family: Calibri">&nbsp;</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLoading: false,
    }
  },
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
